import React from 'react';

import PropTypes from 'prop-types';

import { BtnContainer, Container, Description, IconContainer, ImgContainer, TitleContainer } from './style';
import { PromoDangerouslyHtml } from '../promo-dangerously-html/PromoDangerouslyHtml';
import { PromoText } from '../promo-text/PromoText';
import IconSvg from '../widgets/Illustration/IconSvg';
import PromoIllustration from '../widgets/Illustration/PromoIllustration';

export const QuoteTile = ({ bgColor = 'white', ...props }) => {
    return (
        <Container bgColor={bgColor} isArray={props.isArray}>
            {props.icon && !props.coloredTile && (
                <IconContainer>
                    <IconSvg img={props.icon} />
                </IconContainer>
            )}
            <TitleContainer>
                {props.text && (
                    <PromoDangerouslyHtml
                        tag="div"
                        variant={props.smallTitle ? 'quote' : 'h4'}
                        color={props.coloredTile ? 'white' : 'gray80'}
                        dangerouslyHtml={props.text}
                    />
                )}
                {props.linkText && (
                    <BtnContainer>
                        <PromoText tag="link" variant="link" href={props.pdf ? props.pdf.url : props.linkHref} download={props.pdf ? props.pdf.name : null}>
                            {props.linkText}
                        </PromoText>
                    </BtnContainer>
                )}
            </TitleContainer>
            {props.icon && props.coloredTile && (
                <IconContainer coloredTile={props.coloredTile}>
                    <IconSvg img={props.icon} />
                </IconContainer>
            )}
            {props.img && (
                <ImgContainer>
                    <PromoIllustration img={props.img} loadingLazy={props.loadingLazy} />
                </ImgContainer>
            )}
            {props.description && (
                <Description>
                    <PromoDangerouslyHtml tag="div" color={props.coloredTile ? 'white' : 'gray80'} dangerouslyHtml={props.description} />
                </Description>
            )}
        </Container>
    );
};

QuoteTile.propTypes = {
    isArray: PropTypes.bool,
    icon: PropTypes.object,
    coloredTile: PropTypes.bool,
    bgColor: PropTypes.oneOf([
        'baseColor',
        'white',
        'primary',
        'primaryB2B',
        'purple80',
        'purple40',
        'purple20',
        'purple5',
        'gray80',
        'gray40',
        'gray20',
        'gray5',
        'aubergine01',
        'aubergine02',
        'aubergine03',
        'eggshell01',
        'eggshell02',
        'eggshell03',
        'passionFruit01',
        'passionFruit02',
        'passionFruit03',
        'oceanBlue01',
        'oceanBlue02',
        'oceanBlue03',
        'blueberryBlue01',
        'blueberryBlue02',
        'blueberryBlue03',
        'jade01',
        'jade02',
        'jade03',
    ]),
    smallTitle: PropTypes.bool,
    text: PropTypes.string,
    pdf: PropTypes.object,
    linkHref: PropTypes.string,
    linkText: PropTypes.string,
    img: PropTypes.array,
    description: PropTypes.string,
    loadingLazy: PropTypes.bool,
};
